import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackEvent } from './MetaPixel';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    const eventData = {
      content_name: 'El Arte de Crear Espacios Sagrados',
      content_type: 'product',
      content_ids: ['ebook-espacios-sagrados'],
      content_category: 'eBook',
      value: 7.99,
      currency: 'USD'
    };
    trackEvent('AddToCart', eventData);
    trackEvent('InitiateCheckout', eventData);
  };
  return <AnimatePresence data-id="element-118">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-5 right-5 z-50" data-id="element-119">
          <a href="https://pay.hotmart.com/R104866725J" target="_blank" rel="noopener noreferrer" onClick={handleClick} className="inline-flex items-center gap-2 bg-gold-main text-white font-lora font-semibold text-sm py-3 px-5 rounded-full shadow-lg hover:shadow-xl hover:bg-gold-dark transition-all" data-id="element-120">
            Quiero mi eBook
          </a>
        </motion.div>}
    </AnimatePresence>;
}